<script setup>

import BrowsePicks from "@/components/warehouse/BrowsePicks.vue";
import SlideInDrawer from "@/components/common/navigation/SlideInDrawer.vue";
import DocumentDownload from "@/components/common/other/DocumentDownload.vue";
import {inject} from "vue";

const browsePicks = inject('browsePicks');

</script>

<template>
  <SlideInDrawer
      :height="300"
      title="Available Documents"
      v-model:open-drawer="browsePicks.openDocumentsDrawer">
    <template #icon><i class="fa-solid fa-folder-open" style="color: #eab410;"></i></template>
    <DocumentDownload
        url="Warehouse/documents"
        v-model="browsePicks">
    </DocumentDownload>
  </SlideInDrawer>
<BrowsePicks></BrowsePicks>
</template>

<style scoped>

</style>
